import { Component, OnInit } from '@angular/core';
import { LaunchService } from '../launch.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-region-list',
  templateUrl: './region-list.component.html',
  styleUrls: ['./region-list.component.css']
})
export class RegionListComponent implements OnInit {
  configData: any = {};
  loaded: boolean = false;

  constructor(private launchService: LaunchService, private router: Router) { }

  ngOnInit() {
    console.log('1');
    this.launchService.getConfig().then(data => {
      this.configData = data;
      if (this.configData.regions.length === 1) {
        this.router.navigate(['', this.configData.regions[0].dataKey]);
      }
      this.loaded = true;
    });
  }

}
